export default __webpack_public_path__ + "static/media/abiodun.4f866368.png";